import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../state/appState';

// Crea un slice de Redux para manejar el estado de la aplicación
const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setAssets: (state, action) => {
            state.assets = action.payload;
        },
        setAssetTypes: (state, action) => {
            state.assetTypes = action.payload;
        }
    },
});

// Exporta las acciones generadas por el slice
export const {
    setAssets,
    setAssetTypes,
} = appSlice.actions;

// Exporta el reducer del slice
export default appSlice.reducer;
